export default [
  {
    id: 1,
    title: '執政是選票包袱 政策不是催票紅利',
    subtitle: '',
    description: '不論藍綠執政，他們所繳出的成績單，往往會帶給選票負面衝擊，顯示執政是「包袱」，而非「紅利」。',
    image: require('@/assets/articles/article-1-cover.jpg')
  },
  {
    id: 2,
    title: '藍綠母雞誰強？',
    subtitle: '能帶領小雞進國會殿堂',
    description: '總統和立委選舉一起投票，一位強大的母雞往往能夠神助攻，反之，母雞體質不佳，可能會淪為隊友的拖油瓶。',
    image: require('@/assets/articles/article-2-cover.jpg')
  },
  {
    id: 3,
    title: '第三勢力票在哪裡？',
    subtitle: '民眾黨能複製時力成功模式？',
    description: '第三勢力競逐2020大選，打出超越藍綠的訴求，尤其以台北市長柯文哲為首的台灣民眾黨，能否一舉進攻國會，成為各界矚目焦點。根據近幾年的政黨票分析顯示，小黨必須推區域立委參選，或是有母雞帶頭，才能催化政黨票。',
    image: require('@/assets/articles/article-3-cover.jpg')
  }
]
